module.exports = __webpack_public_path__ + "media/images/favicons/mstile-144x144-57cf07816d6c7cd4ecc9c59f94dbab8d.png";